import React from "react";
import {
  createPixAutomaticoController,
  INITIAL_PIX_AUTOMATICO_STATE,
  type PixAutomaticoController,
  type PixAutomaticoPanelState,
} from "./pixAutomaticoController";

export type UsePixAutomatico = PixAutomaticoPanelState &
  Pick<PixAutomaticoController, "start" | "cancel" | "saveWeeklyLimit" | "retry" | "dismissNotice">;

/**
 * Binds the Pix Automatico controller to a mounted page: it loads on mount,
 * polls while the authorization is still moving, and stops everything, timers
 * included, when the page unmounts.
 */
export function usePixAutomatico(termsVersion: string): UsePixAutomatico {
  const [state, setState] = React.useState<PixAutomaticoPanelState>(INITIAL_PIX_AUTOMATICO_STATE);
  const termsRef = React.useRef(termsVersion);
  termsRef.current = termsVersion;
  const [controller] = React.useState(() =>
    createPixAutomaticoController({ onChange: setState, termsVersion: () => termsRef.current }),
  );

  React.useEffect(() => {
    controller.mount();
    return () => controller.unmount();
  }, [controller]);

  return {
    ...state,
    start: controller.start,
    cancel: controller.cancel,
    saveWeeklyLimit: controller.saveWeeklyLimit,
    retry: controller.retry,
    dismissNotice: controller.dismissNotice,
  };
}
